import { render, staticRenderFns } from "./SettingsPushNotificationsRecipientsModal.vue?vue&type=template&id=182bc314&scoped=true&"
import script from "./SettingsPushNotificationsRecipientsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsPushNotificationsRecipientsModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPushNotificationsRecipientsModal.vue?vue&type=style&index=0&id=182bc314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182bc314",
  null
  
)

export default component.exports